import axios from "axios";

import { LpcConnectionData } from "./lpcConnectionData";

const Logger = require("../services/Logger");
const sharedConfig = require("../config/sharedConfig");

export async function lpcResponse(response) {
  try {
    const resp = await response;
    const { status, data } = resp;

    if (status >= 200 && status < 300) {
      return { success: true, data };
    }
    if (data.error) {
      lpcError(data.error);
    }

    return { success: false, errorMsg: data, errorCode: status };
  } catch (e) {
    lpcError(e);
    return { success: false, errorMsg: e, errorCode: e.response?.status };
  }
}

function lpcError(e) {
  Logger.error("LPC communication error: ", e);
}

export default function getLpcClient(connectionData: LpcConnectionData) {
  const { lpcApiUrl = "", lpcToken = "" } = {
    ...sharedConfig,
    ...connectionData,
  };
  return axios.create({
    baseURL: lpcApiUrl,
    headers: {
      Authorization: lpcToken,
    },
    validateStatus: (status) => {
      return (status >= 200 && status < 300) || status === 409;
    },
  });
}
